import { fixLawHtml, parseLawIds } from '@mattilsynet/design'
import { unified } from 'unified'
import rehypeParse from 'rehype-parse'
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize'
import rehypeStringify from 'rehype-stringify'

const labelParser = unified().use(rehypeParse, { fragment: true })

export function parseLegislationReferences(ids: string[], html: string) {
  return parseLawIds(ids, html).map((part) => ({
    ...part,
    // The Law helper returns HTML-encoded labels. Decode once as inert text;
    // React must still render the result as text, never as HTML.
    label: labelParser
      .parse(part.label.replace(/</g, '&lt;'))
      .children.map((node) => (node.type === 'text' ? node.value : ''))
      .join('')
  }))
}

const processor = unified()
  .use(rehypeParse, { fragment: true })
  .use(rehypeSanitize, {
    ...defaultSchema,
    clobberPrefix: '', // IDs are namespaced per mounted viewer below.
    tagNames: [
      ...(defaultSchema.tagNames ?? []),
      'main',
      'article',
      'section',
      'button'
    ],
    attributes: {
      ...defaultSchema.attributes,
      '*': [...(defaultSchema.attributes?.['*'] ?? []), 'className'],
      button: ['type', 'role', 'ariaLabel', 'ariaChecked', 'value']
    }
  })
  .use(rehypeStringify)

export function prepareLegislationHtml(html: string, prefix: string): string {
  // Sanitize AFTER the design-system helper: it interpolates legal headings into
  // generated button attributes and is not itself a security sanitizer.
  return String(processor.processSync(fixLawHtml(html))).replace(
    / id="([^"]+)"/g,
    ` id="${prefix}-$1"`
  )
}
